import ScheduleEditor from './ScheduleEditor';

export default {
  ScheduleEditor,
};
